import React, { useEffect, useState } from "react"
import labels from "./const"
import useLabels from "../../utils/useLabels"
import Text from "../Text"
import { Button, Col, Container, Row } from "reactstrap"

import * as s from "./style.module.css"
import { LazyLoadImage } from "react-lazy-load-image-component"

function Idea({ lang, type, isReverse }) {
  const [content, setContent] = useState({})
  const t = useLabels(labels, lang)

  useEffect(() => {
    switch (true) {
      case type === "forWho":
        setContent(t.forWho)
        break
      case type === "aroundH4c":
        setContent(t.aroundH4c)
        break
      case type === "river":
        setContent(t.river)
        break
      case type === "forest":
        setContent(t.forest)
        break
      case type === "cooperation":
        setContent(t.cooperation)
        break
      case type === "animatonSumm":
        setContent(t.animatonSumm)
        break
      case type === "ecoFuture":
        setContent(t.ecoFuture)
        break
      default:
        break
    }
  }, [t])

  if (content.image2) {

    return (
      <div id={type} className={isReverse ? s.reverseRoot : s.root}>
        <Container className="h-100">
          <Row className={isReverse && "flex-row-reverse"}>
            <Col lg="5" className="position-relative">
              <div className="mr-4">
                {content && (
                  <div className={s.image2}>
                    {/* <LazyLoadImage effect="blur" src={content.image1} alt="img" />  */}
                    <img src={content.image1} alt="obraz" loading="lazy" />
                    <img alt="" className={s.imageSplash} src={content.splash} />
                    <div className={s.image1}>
                      {/* <LazyLoadImage effect="blur" src={content.image2} alt="img" />  */}
                      <img src={content.image2} alt="tlo" loading="lazy" />
                    </div>
                  </div>
                )}
              </div>
            </Col>
            <Col lg="1" />
            <Col lg="6">
              <div className="mt-4">
                {content && (
                  <Text title={content.title} text={content.description} />
                )}
              </div>
              {type === "aroundH4c" && <div className="mx-auto"><img src={content.ecofuture} alt="ecofuture_investgda" /></div>}
              {type === "river" && <div className="d-flex justify-content-center align-content-center">

                <a href="mailto:kajaki@codeme.pl" target="_blank">
                  <Button
                    color="primary"
                    dangerouslySetInnerHTML={{
                      __html: content.button,
                    }}
                  />
                </a>

                {/*<MailerLitePopup buttonText={content.button}/>*/}

              </div>}
            </Col>
          </Row>
        </Container>
        {type === "forWho" && (
          <img
            className={s.forWhoSplash}
            src={require("./images/splash.svg").default}
          />
        )}
      </div>
    )

  } else {
    return (<div></div>)
  }
}

export default Idea
